<template>
  <header id="header" class="fixed-top">
    <nav class="navbar justify-content-between">
      <div class="left-container">
        <h1 class="logo" @mouseenter="navClose">
          <a href="/">GCRM</a>
        </h1>
        <!-- top navi @mouseleave="navClose"-->
        <ul class="navbar-nav" v-if="userInfo && highestRole">
          <!-- 이하 롤에 따라 나올수도 안나올 수도 있는 메뉴 -->
          <li class="nav-item" v-for="authI18 in getAuthRootMenu()" :key="authI18.authRootCode">
            <!--lv1 메뉴제목 : GCRM, Analystics @mouseover="authMenuClick(authI18.authRootCode)"-->
            <a class="menu-1depth"
              :class="{ on: authI18.authRootCode === selectedAuthRootCode && !selectedMenu.menuId }"
              @click="authMenuClick(authI18.authRootCode)"
              @mouseover="authMenuClick(authI18.authRootCode)"
              href="javascript:void(0)">
              {{ $t(authI18.messageKey) }}
            </a>
            <transition name="fade">
              <!-- 대메뉴가 열고 닫힌다. -->
              <ul
                class="sub-nav" v-if="authI18.authRootCode === selectedAuthRootCode && !selectedMenu.menuId">
                <span
                  v-for="(item, index) in getAuthSubMenu(authI18, 1)"
                  :key="item.regionCode"
                >
                  <li class="sub-item">
                    <template v-if="getAuthSubMenu(authI18, 2).length">
                      <!--lv2 플랫폼 : Campaign, Loyalty -->
                      <a href="javascript:void(0)" class="menu-2depth isSub collapsed" v-b-toggle="`subaccordion-${index}`">
                        {{ getLabel({ labelJson: item.platformCodeLabelJson }) }}
                      </a>
                      <b-collapse :id="`subaccordion-${index}`" accordion="my-accordion" class="sub">
                        <ul class="sub-list">
                          <li v-for="subItem in getAuthSubMenu(item, 2)" :key="subItem.regionCode">
                            <!--lv3 리전 : KR, CN -->
                            <!-- 2022-09-19 매 클릭시점에서 키파람을 새로 만들어야 한다. -->
                            <a href="javascript:void(0)" @click="setExternalUrl(subItem)">
                              {{ getLabel({ labelJson: subItem.regionCodeLabelJson }) }}
                            </a>
                          </li>
                        </ul>
                      </b-collapse>
                    </template>
                    <template v-else>
                      <!-- lv2가 한개뿐 -->
                      <a href="javascript:void(0)" @click="setExternalUrl(item)" class="menu-2depth">
                        {{ getLabel({ labelJson: item.platformCodeLabelJson }) }}
                      </a>
                    </template>
                  </li>
                </span>
              </ul>
            </transition>
          </li>
          <!-- 이하 메뉴 api로부터 호출된 메뉴 -->
          <li class="nav-item" v-for="(menu, index) in rootMenus" :key="menu.menuId" :index="menu.menuId">
            <a
              href="javascript:"
              class="menu-1depth"
              :class="{ on: menu.menuId === selectedMenu.menuId && selectedMenu.isNavOpen }"
              @click="navClick(menu, index)"
              @mouseover="navClick(menu, index)"
            >
              {{ getLabel(menu) }}
            </a>
            <transition name="fade">
              <ul
                class="sub-nav" v-if="menu.menuId === selectedMenu.menuId && selectedMenu.isNavOpen">
                <li
                 :class="{'cstm-hide': ((submenu.menuId === 'AYLObAaaAv0DAd_9') && (userInfo.compCode === 'PC2'))}"
                  class="sub-item"
                  v-for="(submenu, subIndex) in getSubmenu(menu.menuId)"
                  :key="submenu.menuId"
                  :index="submenu.menuId"
                >
                  <template v-if="getSubmenu(submenu.menuId).length > 0">
                    <a href="javascript:" class="menu-2depth isSub collapsed" v-b-toggle="'subaccordion-' + subIndex">
                      {{ getLabel(submenu) }}
                    </a>
                    <b-collapse
                      :id="'subaccordion-' + subIndex" accordion="my-accordion" class="sub">
                      <ul class="sub-list">
                        <li  v-for="item in getSubmenu(submenu.menuId)" :key="item.menuId" >
                          <!-- C6N PC2 a href="javascript:" @click="moveMenu(item.menuUrl, item)" v-if="getLabel(item) !='Tier(USA)' || ( (myCountryCode=='ZZ' || myCountryCode=='US') && getLabel(item) =='Tier(USA)')"-->
                          <a href="javascript:" @click="moveMenu(item.menuUrl, item)" v-if="checkMenuByCountryCode3Level(getLabel(item), myCountryCode)">
                            {{ getLabel(item) }}
                          </a>
                        </li>
                      </ul>
                    </b-collapse>
                  </template>
                  <template v-else>
                    <a
                    v-if="submenu.defaultPage && checkMenuByCountryCode2Level(submenu.label, myCountryCode)"
                      href="javascript:"
                      class="menu-2depth"
                      @click="moveMenu(submenu.defaultPage.pagePath, submenu)"
                      >{{ getLabel(submenu) }}</a
                    >
                  </template>
                </li>
              </ul>
            </transition>
          </li>
        </ul>
        <!-- //navi -->
        <span @mouseenter="navClose" style="line-height:72px; padding-left: 20px; cursor:default;">&nbsp;</span>
      </div>
      <!-- 우측 menu -->
      <div class="right-container" @mouseenter="navClose">
        <div class="myinfo" v-if="userInfo && highestRole">
          <button type="button" class="btn-myinfo" @click="onInfoClick" v-if="!isRewardsUser">{{ userInfo.userName }}</button>
          <button type="button" class="btn-myinfo" @click="onInfoClick" v-if="isRewardsUser"
            style="width: 100px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            >
            {{ userInfo.userName }}
          </button>
          <transition name="slide">
            <div v-if="isMyInfoActive" class="myinfo-dropdown">
              <div class="in">
                <div class="info-hd">
                  {{ getLabel({ labelJson: roleCodeLabelJson }) }}
                </div>
                <div class="info-cnt">
                  <ul class="ul">
                    <span v-for="(item, index) in userAuthListGroupByRegion" :key="item.regionCode">
                      <li v-if="!index || item.platformCode !== userAuthListGroupByRegion[index - 1].platformCode">
                        <button type="button" class="i-menu collapsed" v-b-toggle="'accordion-' + index">
                          {{ getLabel({ labelJson: item.platformCodeLabelJson }) }}
                        </button>
                        <b-collapse :id="'accordion-' + index" accordion="my-accordion" class="sub">
                          <ul>
                            <span v-for="subItem in userAuthListGroupByRegion" :key="subItem.regionCode">
                              <li v-if="item.platformCode === subItem.platformCode">
                                {{ getLabel({ labelJson: subItem.regionCodeLabelJson }) }}
                              </li>
                            </span>
                          </ul>
                        </b-collapse>
                      </li>
                    </span>
                  </ul>
                </div>
                <div class="info-btm">
                  <button type="button" class="btn btn-secondary btn-xs" @click="logoutConfirmFn">Logout</button>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="global" v-if="isRewardsUser">
          <!-- <button v-if="isRewardsUser" type="button" @click="onGlobalClick">global</button> -->
          <button class="btn_global" type="button" @click="onGlobalClick">
            <label
            :tooltip="myCountryName + '('+ myCountryOffset + ')'" tooltip-position="bottom"
            >
              {{myCountryName}}
            </label>
          </button>
          <transition name="slide">
            <div v-if="isMyGlobalActive" class="global-dropdown">
              <div class="in">
                <div class="info-cnt">
                  <ul class="ul">
                    <span v-for="(item, index) in userCountryListGroupByRegion" :key="item.countryCode">
                      <li v-if="!index || item.countryRegion !== userCountryListGroupByRegion[index - 1].countryRegion">
                        <button type="button" class="i-menu collapsed" v-b-toggle="'accordion-' + index">
                          {{ item.countryRegion }}
                        </button>
                        <b-collapse :id="'accordion-' + index" accordion="my-accordion" class="sub">
                          <ul>
                            <span v-for="subItem in userCountryListGroupByRegion" :key="subItem.countryCode">
                              <li v-if="item.countryRegion === subItem.countryRegion" @click="onChangeGlobal(subItem.countryCode,subItem.countryOffset)">
                                {{  subItem.countryName  }} ({{subItem.countryOffset}})
                              </li>
                            </span>
                          </ul>
                        </b-collapse>
                      </li>
                    </span>
                  </ul>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="lang">
          <select class="form-control" @change="changeLocale" v-model="selectedLocale">
            <option
              v-for="locale in availableLocales"
              :key="locale"
              :data-locale="locale"
              :class="{ selected: locale === $i18n.locale }"
              :value="locale"
            >
              {{ getLocaleLabel(locale) }}
            </option>
          </select>
        </div>
      </div>
    </nav>

    <form ref="keyParamFormHeader" name="keyParamFormHeader"
       method="post" target="newWin">
      <input type="hidden" name="key_param" v-model="key_param" />
    </form>
  </header>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import axios from 'axios';
import { relativeTimeThreshold } from 'moment';
import store from '@/vuex/store';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil } from '@/utils';
import loginService from '@/service/loginService';
import PopupLoyaltyKorea from './PopupLoyaltyKorea';

export default {
  mixins: [SDLLocale],
  data() {
    return {
      menuSelectedIndex: null,
      isMyInfoActive: false,
      isMyGlobalActive: false,
      userInfo: {}, // jwt token 정보
      myAuthInfo: {}, // api 통한 유저정보
      myGlobalInfo: {}, // api 통한 유저정보
      userAddInfo: {}, // api 통한 정보 중 userAddInfo만 따로 분리함.
      roleCodeLabelJson: {},
      selectedMenu: {},
      selectedAuthMenu: {}, // authRootCode === 'GCSYS_003'
      i18AuthMenuList: [
        {
          authRootCode: 'GCSYS_003',
          messageKey: 'sdl.gcrm.main.gcsys.003',
        },
        {
          authRootCode: 'GCSYS_002',
          messageKey: 'sdl.gcrm.main.gcsys.002',
        },
      ],
      selectedAuthRootCode: '',
      selectedLocale: 'ko_KR',
      userAuthListGroupByRegion: [],
      userCountryListGroupByRegion: [],
      key_param: null,
      target_url: '',
      allowRolesForExternelUrl: ['GC_IT_ADMIN_ROLE', 'GC_ADMIN_ROLE', 'GC_USER_ROLE'], // GCRM, Analytics 메뉴가 허락되는 롤들.
      selectedDepth2Menu: '',
      isRewardsUser: (String(localStorage.getItem('isRewardsUser')).toLowerCase() === 'true'),
      myCountryCode: localStorage.getItem('countryCode'),
      myCountryName: '',
      myCountryOffset: '',
      menuCntryList: [],
      manualPointCntryList: [],
      tierUpgradeCntryList: [],
      tierCntryList: [],
    };
  },
  async created() {
    this.userInfo = SDLUtil.getLoginedUserInfo();
    if (this.userInfo) {
      // this.key_param = this.getKeyParam();
      await this.getMyAuth(); // set myAuthInfo
      await this.getMyGlobal(); // set myGlobalInfo
      this.setMyGroupRegionList(); // userAuthListGroupByRegion
      await this.getMenuCountry('ManualPointMgt');
      await this.getMenuCountry('TierUpgradeMgt');
      await this.getMenuCountry('TierMgt');
    }
  },
  mounted() {
    const lang = this.getLocale().split('_')[0];
    this.selectedLocale = this.getLocale();
    document.documentElement.setAttribute('lang', lang);
  },
  computed: {
    ...mapGetters({
      menus: 'getMenus', // Receive menus with getter
      highestRole: 'getHighestRole',
    }),
    rootMenus() {
      const rm = _.sortBy(
        this.menus.filter(menu => menu.menuLevel === 1 && menu.menuId !== 'COMM_URL'),
        ['menuSequence'],
      );
      rm.map(m => {
        m.isNavOpen = false;
        return m;
      });
      return rm;
    },
    availableLocales() {
      return this.$i18n.availableLocales;
    },
    newNoticeCount() {
      return this.noticeList.filter(notice => !notice.noticeChecked).length;
    },
  },
  methods: {
    ...mapActions(['logout', 'setLocale', 'setLanguageList']),
    ...mapGetters({
      getAuthInfo: 'getAuthInfo',
      getHighestRole: 'getHighestRole',
      getLocale: 'getLocale',
      // getKeyParam: 'getKeyParam',
    }),
    changeLocale() {
      const locale = this.selectedLocale;
      this.$i18n.locale = locale;
      this.setLocale(locale);
      if (this.userInfo) {
        this.updateUserToken({ language: locale });
        const lang = this.getLocale().split('_')[0];
        document.documentElement.setAttribute('lang', lang);
      }
    },
    getLocaleLabel(locale) {
      return this.$i18n.getLocaleMessage(locale)['sdl.common.language.label'];
    },
    updateUserToken(param) {
      const params = {
        language: this.userInfo.language,
        timeZoneId: this.userInfo.timeZoneId,
        timeZoneCode: this.userInfo.timeZoneCode,
        ...param,
      };

      axios.put(`${SDLUtil.API_URL}/auth/users/user-token`, params).then(({ data }) => {
        loginService.setToken(data.jwtToken);
        this.userInfo = SDLUtil.getLoginedUserInfo();
      });
    },
    getSubmenu(menuId) {
      return _.sortBy(
        this.menus.filter(menu => menu.parentId === menuId),
        ['menuSequence'],
      );
    },
    async getMyAuth() { // 내 권한정보
      this.myAuthInfo = this.getAuthInfo(); // from store.getters
      /*
      this.myAuthInfo = await this.getAuthInfo().catch(err => {
        console.warn(err);
      }); // from store.getters
      */
      if (!_.isEmpty(this.myAuthInfo)) {
        this.userAddInfo = this.myAuthInfo.userAddInfo ? { ...this.myAuthInfo.userAddInfo } : {};
        try {
          if (!_.isEmpty(this.userAddInfo)) {
            this.roleCodeLabelJson = JSON.parse(this.userAddInfo.roleCodeLabelJson);
          }
        } catch (error) {
          console.warn(error);
          this.roleCodeLabelJson = {};
        }
      }
    },

    async getMyGlobal() { // 내 global정보
      const res = await axios.get(`${SDLUtil.API_URL}/auth/myAllCountryInfo`).catch(err => {
        console.warn('call auth/logout : ', err);
      });
      if (res.status === 200) {
        this.myGlobalInfo = res.data;
        if (this.myGlobalInfo.length > 0) {
          // eslint-disable-next-line eqeqeq
          this.myCountryNameObj = this.myGlobalInfo.filter(opt => opt.countryCode == this.myCountryCode);
          if (this.myCountryNameObj.length > 0) {
            this.myCountryName = this.myCountryNameObj[0].countryName;
            this.myCountryOffset = this.myCountryNameObj[0].countryOffset;
            localStorage.setItem('countryCode', this.myCountryNameObj[0].countryCode);
            localStorage.setItem('countryOffset', this.myCountryNameObj[0].countryOffset);
          } else if (this.myCountryName == '' || this.myCountryNameObj.length == 0) {
            this.myCountryName = this.myGlobalInfo[0].countryName;
            this.myCountryOffset = this.myGlobalInfo[0].countryOffset;
            localStorage.setItem('countryCode', this.myGlobalInfo[0].countryCode);
            localStorage.setItem('countryOffset', this.myGlobalInfo[0].countryOffset);
          }
        } else {
          this.myCountryName = '';
          this.myCountryOffset = '';
          localStorage.setItem('countryCode', '');
          localStorage.setItem('countryOffset', '');
        }

        this.setMyGlobalList();
      }
    },
    setMyGroupRegionList() { // 유저의 그룹바이 리전정보에서 JSON.parse 및 플래그에 맞춰 key_param이 조합된 joinUrl을 추가함. 이어서 소팅하여 반환.
      try {
        if (Array.isArray(this.myAuthInfo.userAuthListGroupByRegion)) {
          let uar = [...this.myAuthInfo.userAuthListGroupByRegion];
          uar.forEach(item => {
            item.platformCodeLabelJson = typeof item.platformCodeLabelJson === 'object' ? item.platformCodeLabelJson : JSON.parse(item.platformCodeLabelJson);
            item.regionCodeLabelJson = typeof item.regionCodeLabelJson === 'object' ? item.regionCodeLabelJson : JSON.parse(item.regionCodeLabelJson);
            item.regionCodeDescription = typeof item.regionCodeDescription === 'object' ? item.regionCodeDescription : JSON.parse(item.regionCodeDescription);
          });
          uar = _.sortBy(uar, ['platformCode']);
          this.userAuthListGroupByRegion = [...uar];
        }
      } catch (error) {
        console.warn(error);
      }
    },
    setMyGlobalList() {
      try {
        if (Array.isArray(this.myGlobalInfo)) {
          let uar = [...this.myGlobalInfo];
          uar = _.sortBy(uar, ['countryRegion']);
          this.userCountryListGroupByRegion = [...uar];
        }
      } catch (error) {
        console.warn(error);
      }
    },
    getAuthRootMenu() { // 권한이 있는 사용자에 대해, 헤더의 대메뉴(제목항)를 만든다.
      if (!this.allowRolesForExternelUrl.includes(this.highestRole)) {
        return [];
      }
      const topMenu = [];
      const rs = [];
      this.i18AuthMenuList.forEach(el => {
        // 유저가 가지고 있는것을 순회하면서, 대메뉴에 올라갈 메뉴를 추린다.
        this.userAuthListGroupByRegion.forEach(menu => {
          if (menu.platformCode.substr(0, 9) === el.authRootCode && !topMenu.includes(el.authRootCode)) {
            topMenu.push(el.authRootCode);
            rs.push({
              ...el,
              platformCode: menu.platformCode,
              platformCodeLabelJson: menu.platformCodeLabelJson,
            });
          }
        });
      });
      return rs;
    },
    authMenuClick(authRootCode) { // 권한이 있는 사용자의 대메뉴가 클릭됨. 밑줄 긋고, 도큐먼트바디에 액션 박아둠.
      this.selectedMenu = {}; // 다른 대메뉴가 열렸으면 닫기 위해.
      this.selectedAuthRootCode = authRootCode; // 대메뉴가 선택되면 하단에 '하얀색 밑줄'이 나오게 하기위해.
      document.addEventListener('click', e => {
        if (!e.target.closest('.nav-item')) {
          this.selectedAuthRootCode = '';
        }
      });
    },
    getAuthSubMenu(el, menuLevel) { // 권한이 있는 사용자의 소메뉴 만들기.
      // 유저가 가지고 있는것을 순회하면서, 서브메뉴(플랫폼(lv1) 혹은 리전(lv2)) 목록을 추린다.
      let rs = [];
      const platforms = [];
      switch (menuLevel) {
        case 1:
          this.userAuthListGroupByRegion.forEach(menu => {
            if (menu.platformCode.substr(0, 9) === el.authRootCode && !platforms.includes(menu.platformCode)) {
              platforms.push(menu.platformCode);
              rs.push(menu);
            }
          });
          break;
        default:
          // menuLevel === 2
          rs = this.userAuthListGroupByRegion.filter(menu => menu.platformCode === el.platformCode);
          if (rs.length === 1 && el.authRootCode === 'GCSYS_002') {
            rs = []; // 그룹바이 리전에서 한개만 찾아졌고, Analystics면 그냥 그 자신이 첫메뉴로 한다.
          }
          break;
      }
      return rs;
    },
    moveMenu(pagePath, item) {
      store.commit('PARAMS', {});
      this.selectedMenu = { menuId: 'adromeda' };
      if (item.externalUrlUsed) {
        const url = item.externalUrl;
        window.open(url.startsWith('http') ? url : `http://${url}`, '_blank');
      } else {
        this.$router.push({ path: pagePath }).catch(e => e); // same url calling error muted
      }
    },
    navClick(menu, index) {
      // 메뉴 오픈, 클로스 용도
      this.menuSelectedIndex = index;
      this.rootMenus.forEach(item => {
        item.isNavOpen = false;
      });
      menu.isNavOpen = true;
      this.selectedMenu = { ...menu };
      document.addEventListener('click', e => {
        if (!e.target.closest('.nav-item')) {
          this.selectedMenu.isNavOpen = false;
        }
      });
    },
    navClose() {
      this.menuSelectedIndex = -1;
      this.rootMenus.forEach(item => {
        item.isNavOpen = false;
      });
      this.authMenuClick();
    },
    logoutConfirmFn() {
      SDLUtil.confirm({
        msg: 'sdl.gcrm.main.confirm.logout',
        title: 'sdl.common.label.confirm',
        onOkEvt: () => {
          this.goLoginPage();
        },
      });
    },


    async goLoginPage() {
      store.commit('LOGOUT_CALLED', true);
      const res = await axios.put(`${SDLUtil.API_URL}/auth/logout?checkPrivacyPolicy=true`).catch(err => {
        console.warn('call auth/logout : ', err);
        // this.$router.push(`${this.$context}/error`);
      });
      this.logout(); // --> setToken('')
      this.myAuthInfo = null;
      this.myGloabalInfo = null;
      this.userInfo = null;
      localStorage.setItem('countryCode', '');
      localStorage.setItem('countryOffset', '');
      if (res && res.status === 200) {
        this.$router.push(`${this.$context}/login`);
      }
    },
    onInfoClick() {
      this.isMyInfoActive = !this.isMyInfoActive;
      document.addEventListener('click', e => {
        if (!e.target.closest('.myinfo')) {
          this.isMyInfoActive = false;
        }
      });
    },
    onGlobalClick() {
      this.isMyGlobalActive = !this.isMyGlobalActive;
      document.addEventListener('click', e => {
        if (!e.target.closest('.global')) {
          this.isMyGlobalActive = false;
        }
      });
    },
    onChangeGlobal(countryCode, countryOffset) {
      localStorage.setItem('countryCode', countryCode);
      localStorage.setItem('countryOffset', countryOffset);
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    },
    openPopupLoyaltyKorea() {
      SDLUtil.show(
        PopupLoyaltyKorea,
        {
        },
        {
          width: '600px',
          height: 'auto',
        },
      );
    },

    async setExternalUrl(item) {
      // 20230321 moonsooj, if Loyalty Korea then popup

      if (item.regionCode === 'GCSYS_0030020050000') {
        this.openPopupLoyaltyKorea();
        return;
      }
      if (Number(item.regionCodeDescription.key_param_flag)) {
        // let keyParam = '';
        // 빈 문자열로 전달하는 경우 => 로그인한유저녹스아이디 + "|" + 클릭시각(요청시간)의 데이터를 암호화 하여 리턴한다.
        /*
        const keyRes = await axios.post(`${SDLUtil.API_URL}/gcrm/seed/encrypt`, { data: '' }).catch(err => {
          console.warn(err);
        });
        if (keyRes && keyRes.status === 200 && !_.isEmpty(keyRes.data)) {
          this.key_param = keyRes.data.data;
          this.$refs.keyParamFormHeader.action = item.regionCodeDescription.url;
          this.$refs.keyParamFormHeader.submit();
        } else {
          SDLUtil.errorAlert();
        }
*/
        axios.post(`${SDLUtil.API_URL}/gcrm/seed/encrypt`, { data: '' })
          .then(({ data }) => {
            this.key_param = data.data; // key_param
            this.$refs.keyParamFormHeader.key_param.value = data.data;
            // console.log(this.key_param);
            // console.log(item.regionCodeDescription.url);
            // console.log(this.$refs.keyParamFormHeader.key_param.value);
            this.$refs.keyParamFormHeader.action = item.regionCodeDescription.url;
            this.$refs.keyParamFormHeader.submit();
          })
          .catch(err => {
            console.error(err);
            SDLUtil.showLoadingBar(false);
            SDLUtil.errorAlert(err);
          });
      } else {
        window.open(item.regionCodeDescription.url);
      }
    },

    checkMenuByCountryCode2Level(item, myCountryCode) {
      let checked = false;

//console.log(this.manualPointCntryList);

      if (item === 'Manual Point Mgmt.') {
        for (let i = 0; i < this.manualPointCntryList.length; i++) {
          if (this.manualPointCntryList[i].code === myCountryCode) {
            checked = true;
            break; // This will exit the loop when the first even number is found
          }
        }
      }

      if (item === 'Tier Upgrade Mgmt.') {
        for (let i = 0; i < this.tierUpgradeCntryList.length; i++) {
          if (this.tierUpgradeCntryList[i].code === myCountryCode) {
            checked = true;
            break; // This will exit the loop when the first even number is found
          }
        }
      }

      if (item !== 'Tier Upgrade Mgmt.' && item !== 'Manual Point Mgmt.') checked = true;

      //     if (item === 'Manual Point Mgmt.' && (myCountryCode === 'ZZ' || myCountryCode === 'US' || myCountryCode === 'BR' || myCountryCode === 'SG')) checked = true;

      //if (item === 'Tier Upgrade Mgmt.' && (myCountryCode === 'ZZ' || myCountryCode === 'US')) checked = true;
      return checked;
    },

    checkMenuByCountryCode3Level(item, myCountryCode) {
      let checked = false;

      if (item !== 'Tier(USA)') checked = true;
      if (item === 'Tier(USA)' && (myCountryCode === 'ZZ' || myCountryCode === 'US')) checked = true;

      return checked;
    },

    async getMenuCountry(value) { // 내 global정보
      axios.get(`${SDLUtil.API_URL}/commcode/GC_MENU_BY_CNTRY/${value}/commcodes`).then(({ data }) => {
        this.menuCntryList = data;
        if (value === 'ManualPointMgt') this.manualPointCntryList = data;
        if (value === 'TierUpgradeMgt') this.tierUpgradeCntryList = data;
        if (value === 'TierMgt')        this.tierCntryList = data;
      });

     // if (value === 'ManualPointMgt') this.manualPointCntryList = this.menuCntryList;
     // if (value === 'tierUpgradeMgt') this.tierUpgradeCntryList = this.menuCntryList;
     // if (value === 'tierMgt') this.tierCntryList = this.menuCntryList;
    },


  },
};
</script>
<style scoped>
.cstm-hide {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/admin/main/GcrmHeader.vue